export default "__VITE_ASSET__B234F3tt__"